export { default as Hero } from './hero/Hero';
export { default as Faq } from './faq/Faq';
export { default as Features } from './features/Features';
export { default as Footer } from './footer/Footer';
export { default as Team } from './team/Team';




// WEBPACK FOOTER //
// ./src/containers/index.js